<template>
  <div 
    :class="[size === 'large' ? 'nav-md' : 'nav-sm']">
    <div class="container body">
      <div class="main_container">
        <sidebar
          title="Edexis"
          :menuItems="menuItems"
          :logout="logout.bind(this)"
        ></sidebar>
        <topmenu
          v-on:toggleSidebar="toggleSidebar()"
        ></topmenu>
        <div class="right_col" role="main" style="min-height: 1080px;">

          <router-view></router-view>

        </div>
        <!-- footer content -->
        <footer>
          <div class="clearfix"></div>
        </footer>
        <!-- /footer content -->
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Layout/Sidebar'
import Topmenu from '@/components/Layout/Topmenu'
import store from '@/components/store.js'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'app',
  components: {
    Sidebar,
    Topmenu,
    store
  },
  data () {
    return {
      size: 'large',
      hiddenWidth: 900,
      menuItems: [
        {
          title: 'Tasks',
          name: 'tasks',
          icon: 'fa-tasks'
        },
        {
          title: 'Error Logs',
          name: 'logs',
          icon: 'fa-print',
          pill: ''
        }
      ]
    }
  },
  mounted () {
    window.addEventListener('resize', this.checkWidth)

    this.$log('error').count().then(count => {
      this.$set(this.menuItems[1], 'pill', count)
    })
  },
  methods: {
    ...mapActions([
      'buildApiReqeust',
      'updateUser'
    ]),
    logout () {
      this.$user().logout().then(() => {
        this.$router.push('/login')
      })
    },
    toggleSidebar () {
      if (this.size === 'large') {
        this.$set(this, 'size', 'small')
        return false
      }
      this.$set(this, 'size', 'large')
    },
    getWidth () {
      return document.body.scrollWidth
    },
    checkWidth () {
      if (this.getWidth() > this.hiddenWidth) {
        return false
      }
      this.$set(this, 'size', 'large')
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  watch: {
    $route () {
      this.checkWidth()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Console.vue?0df111b4